/**
 * Custom Hook: useLanguage
 * Manages language selection with persistent localStorage support
 * @returns {[string, Function]} Current language code and setter function
 */
import { useState, useEffect } from 'react';
import { storageManager } from '../utils/storageManager';

export const useLanguage = () => {
  const [language, setLanguage] = useState(() => storageManager.getSavedLanguage());

  useEffect(() => {
    storageManager.saveLanguage(language);
  }, [language]);

  return [language, setLanguage];
};
